import DataTableCell from "@eisinc/MobiusOverrides/DataTable/DataTableCell";

export default DataTableCell;

export * from "@eisinc/MobiusOverrides/DataTable/DataTableCell";
